import { CLEAR_MEAL_PLAN_DAY } from "./actionTypes";

export default (day) => ({
  type: CLEAR_MEAL_PLAN_DAY,
  payload: {
    day
  },
});
